"use client";
import * as React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PlaceIcon from "@mui/icons-material/Place";
import { useState } from "react";
import { ApiService } from "../../services/AppService";
import { getToken } from "../../services/HolderService";
import { Address, ResponseObject } from "../../classes/main";
import { AddressInputDialog } from "./AddressInputDialog";

interface LocationDialogProps {
  setCloseDialog: any;
  setLocation: any;
  setLoading: any;
}

const AddressLocationDialog: React.FC<LocationDialogProps> = ({
  setCloseDialog,
  setLocation,
  setLoading,
}) => {
  const apiService = React.useMemo(() => new ApiService(), []);
  const [open, setOpen] = useState(false);
  const [address, setAddress] = useState<undefined>(undefined);
  const [updateAddress, setUpdateAddress] = React.useState(false);
  const [addresses, setAddresses] = useState<Address[]>([]);
  const [updateAddressFlag, setUpdateAddressFlag] = React.useState(false);
  // const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const [selectedAddress, setSelectedAddress] = React.useState<any>(null);

  // const openDropDown = Boolean(anchorEl);

  // const handleClick = (event: React.MouseEvent<HTMLElement>, address: any) => {
  //   event.stopPropagation();
  //   setAnchorEl(event.currentTarget);
  //   setSelectedAddress(address); // Store the selected addres
  // };

  // const handleCloseAddressDropdown = () => {
  //   setAnchorEl(null);
  // };

  // const handleUpdateAddress = async (selectedAddress: any) => {
  //   setAddress(selectedAddress);
  //   handleCloseAddressDropdown();
  //   setOpen(true);
  //   setUpdateAddressFlag(true);
  // };

  // const handleDeleteAddress = async (selectedAddress: any) => {
  //   try {
  //     const responseObject: ResponseObject =
  //       await apiService.delete<ResponseObject>(
  //         apiService.deleteCustomerAddresses +
  //           "?addressId=" +
  //           selectedAddress?.id,
  //         getToken()!
  //       );
  //   } catch (error) {
  //     console.log("Error:", error);
  //   }
  //   handleCloseAddressDropdown();
  //   setUpdateAddress(true);
  // };

  const getAddresses = React.useCallback(async () => {
    const responseObject = await apiService.get<ResponseObject>(
      apiService.customerAddresses,
      getToken()!
    );
    if (responseObject?.status == "success") {
      setAddresses(responseObject.object);
    }
  }, [apiService]);

  React.useEffect(() => {
    getAddresses();
    setUpdateAddress(false);
  }, [updateAddress, getAddresses]);

  //   React.useEffect(() => {
  //     const addressFromLocalStorage = JSON.parse(
  //       atob(localStorage.getItem("address") as string)
  //     );
  //     console.log(addressFromLocalStorage, "addressFromLocalStorage--------");
  //     setAddress(addressFromLocalStorage);
  //   }, []);

  const handleClickOpen = () => {
    const addressFromStorage = JSON.parse(
      atob(localStorage.getItem("address") as string)
    );
    setOpen(true);
    setAddress({
      ...addressFromStorage,
      building: "",
      locality: "",
      formattedAddress: "",
    });
  };

  const handleClose = () => {
    setOpen(false);
    setUpdateAddressFlag(false);
  };

  function selectAddress(item: any) {
    localStorage.setItem("address", btoa(JSON.stringify(item)));
    setLocation({
      latitude: item?.latitude,
      longitude: item?.longitude,
    });
    setCloseDialog();
    setLoading(true);
  }

  return (
    <React.Fragment>
      <Box sx={{ width: "100%" }}>
        <Box>
          <Typography
            variant="body2"
            onClick={handleClickOpen}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              color: "#15741a",
              fontWeight: "bold",
            }}
          >
            <AddCircleIcon sx={{ paddingRight: "0.5rem" }} />
            Add New Address
          </Typography>
        </Box>
        <Box>
          {addresses
            ? addresses.map((item, index) => (
                <Box
                  key={"AddressCard" + index}
                  onClick={() => selectAddress(item)}
                  sx={{
                    width: "-webkit-fill-available",
                    height: "auto",
                    minHeight: "2rem",
                    borderRadius: "0.5rem",
                    boxShadow: "1px 1px 4px 1px rgba(0, 0, 0, 0.15)",
                    padding: "0.5rem",
                    margin: "1rem auto",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "start",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "strat",
                      }}
                    >
                      <Box>
                        <PlaceIcon sx={{ height: "1rem", marginTop: "5px" }} />
                      </Box>
                      <Typography variant="caption">
                        <span
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {item?.formattedAddress ?? ""}
                        </span>
                        <br />
                        {item?.building ?? ""}
                        <br />
                        {item?.locality ?? ""}
                      </Typography>
                    </Box>
                    {/* <Box>
                    <IconButton
                      size="large"
                      aria-label="display more actions"
                      edge="end"
                      color="inherit"
                      onClick={(event) => handleClick(event, address)}
                    >
                      <MoreIcon />
                    </IconButton>
                  </Box> */}
                  </Box>
                  {/* <Box
                  sx={{
                    position: "absolute",
                    bottom: "12px",
                    right: "12px",
                  }}
                >
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => selectAddress(address)}
                    sx={{
                      textTransform: "capitalize",
                    }}
                  >
                    select
                  </Button>
                </Box> */}
                  {/* <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={openDropDown}
                  onClose={handleCloseAddressDropdown}
                  // onClick={handleCloseAddressDropdown}
                  slotProps={{
                    paper: {
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        "&::before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    },
                  }}
                  transformOrigin={{
                    horizontal: "right",
                    vertical: "top",
                  }}
                  anchorOrigin={{
                    horizontal: "right",
                    vertical: "bottom",
                  }}
                >
                  <MenuItem
                    onClick={() => handleUpdateAddress(selectedAddress)}
                  >
                    Update Address
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleDeleteAddress(selectedAddress)}
                  >
                    Delete Address
                  </MenuItem>
                </Menu> */}
                </Box>
              ))
            : Array.from({ length: 3 }).map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  sx={{
                    margin: "2rem 0.5rem",
                    width: "370px",
                    height: "170px",
                  }}
                />
              ))}
        </Box>
      </Box>
      <AddressInputDialog
        addressForSave={address}
        addressOpen={open}
        handleClose={handleClose}
        updateAddressList={() => setUpdateAddress(true)}
        updateAddressFlag={updateAddressFlag}
      />
    </React.Fragment>
  );
};

export default AddressLocationDialog;
